import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import React from "react";
const ItemStore = (props) => {
  let { item, idx, onEdit, onDelete, quyenSua, quyenXoa } = props;
  return (
    <div className="custom-table-row">
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">{idx + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-25 flex-basis-25-sm">
        <span className="mobile-column-name">Tên kho</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.StoreName}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-45 flex-basis-45-sm">
        <span className="mobile-column-name">Địa chỉ</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.StoreAddress}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Trạng thái</span>
        <div className="center-wrapper">
          <p className="text-center color7">
            {item.StoreStatus === 1 && (
              <span className="canh-bao-no ">Còn chỗ</span>
            )}
            {item.StoreStatus === 0 && (
              <span class="canh-bao-red">Hết chỗ</span>
            )}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm ">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            {quyenSua && (
              <a href={() => false} onClick={onEdit}>
                <PopoversBootrap
                  contentText="Sửa"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <img src="/app-assets/images/icon-edit-v2.png" />
                </PopoversBootrap>
              </a>
            )}
            {quyenXoa && (
              <a href={() => false} onClick={onDelete}>
                <PopoversBootrap
                  contentText="Xoá"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <img src="/app-assets/images/icon-xoa-v2.png" />
                </PopoversBootrap>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ItemStore;
